import cx from 'classnames'

import Styles from './SkeletonLoader.module.scss'
import Shared from '../../Shared.module.scss'

import RightPanelContent from '../RightPanelContent/RightPanelContent'
import { Skeleton } from 'antd'

import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const SkeletonLoader = () => {
  const { isTabletPortrait } = useResponsiveDesign()

  return (
    <div className={Shared.content}>
      <div className={cx(Shared.leftPanel, Styles.leftPanel, { [Styles.mobile]: isTabletPortrait })}>
        <Skeleton className={cx(Styles.skinny, Styles.progressSkeleton)} active paragraph={false} />
        <Skeleton className={cx(Styles.thick, Styles.headerSkeleton)} active paragraph={false} />
        <Skeleton className={cx(Styles.skinny, Styles.subHeaderSkeleton)} active paragraph={false} />
        <Skeleton
          className={cx(Styles.thick, Styles.paragraph1, { [Styles.mobile]: isTabletPortrait })}
          active
          paragraph={false}
        />
        <Skeleton
          className={cx(Styles.thick, Styles.paragraph2, { [Styles.mobile]: isTabletPortrait })}
          active
          paragraph={false}
        />
        <Skeleton
          className={cx(Styles.thick, Styles.paragraph1, { [Styles.mobile]: isTabletPortrait })}
          active
          paragraph={false}
        />
        <Skeleton
          className={cx(Styles.thick, Styles.paragraph2, { [Styles.mobile]: isTabletPortrait })}
          active
          paragraph={false}
        />
      </div>
      {!isTabletPortrait && <RightPanelContent screen={'continueWithEmailOrGmail'} />}
    </div>
  )
}
